import React from 'react';
import {
  withIsEnabledContext,
  SurveyContext,
  SurveyResponseContext,
  IsEnabledContext,
  WithIsEnabledInjectedProps,
} from '../Contexts';
import SurveyItem from '../../util/SurveyItem';
import Survey from '../../util/Survey';
import SurveyResponse from '../../util/SurveyResponse';

export interface HOCInputProps {
  surveyItem: SurveyItem;
}

export interface WithCheckForEnablementInjectedProps extends Object {
  surveyItem: SurveyItem;
  isEnabled: boolean;
}

export default <OtherProps extends {}>(
  WrappedComponent: React.ComponentType<
    OtherProps & WithCheckForEnablementInjectedProps
  >,
) => {
  class WithIsEnabled extends React.PureComponent<
    OtherProps & HOCInputProps & WithIsEnabledInjectedProps
  > {
    renderWithContext = (
      isEnabledHOCSurvey: Survey,
      isEnabledHOCSurveyResponse: SurveyResponse,
    ) => {
      const { isEnabled, surveyItem, ...toPass } = this.props;

      // if an uptree-item is disabled, so is this
      let childIsEnabled = isEnabled as boolean;

      if (childIsEnabled) {
        childIsEnabled = isEnabledHOCSurvey.getIsItemEnabled(
          this.props.surveyItem.link,
          isEnabledHOCSurveyResponse,
        );
      }

      return (
        <IsEnabledContext.Provider value={childIsEnabled}>
          <WrappedComponent
            isEnabled={childIsEnabled}
            surveyItem={surveyItem}
            {...(toPass as OtherProps)}
          />
        </IsEnabledContext.Provider>
      );
    };

    render() {
      return (
        <SurveyContext.Consumer>
          {(isEnabledHOCSurvey: Survey) => (
            <SurveyResponseContext.Consumer>
              {(isEnabledHOCSurveyResponse: SurveyResponse) =>
                this.renderWithContext(
                  isEnabledHOCSurvey,
                  isEnabledHOCSurveyResponse,
                )
              }
            </SurveyResponseContext.Consumer>
          )}
        </SurveyContext.Consumer>
      );
    }
  }

  return withIsEnabledContext(WithIsEnabled);
};
